import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { ImportantNotes } from 'PyzShopUi/scripts/product-detail-page/components/ImportantNotes';

let notesContainerRoot;

export const displayImportantNotes = (notes: any): void => {
    const notesContainer = document.querySelector('.important-notes-wrapper');
    const hideClass = 'is-hidden';

    if (notesContainer) {
        if (!notesContainerRoot) {
            notesContainerRoot = createRoot(notesContainer);
        }
        notesContainerRoot.render(<React.Suspense fallback=""><ImportantNotes notes={notes} /></React.Suspense>);

        if (notes.length) {
            notesContainer.classList.remove(hideClass);
        } else {
            notesContainer.classList.add(hideClass);
        }
    }
}
